import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=2ec9a056&scoped=true&"
var script = {}
import style0 from "./Templates.vue?vue&type=style&index=0&id=2ec9a056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec9a056",
  null
  
)

export default component.exports